import { isActiveInWindow } from '@griply/utils';
import { addDays, endOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';

import { useActiveTasks } from './use-active-tasks';

// Window length in days after today (tomorrow through today + UPCOMING_WINDOW_DAYS).
export const UPCOMING_WINDOW_DAYS = 9;

export const useUpcomingTenDaysTasks = () => {
  const today = useToday();
  const activeTasks = useActiveTasks();

  return useMemo(() => {
    const start = addDays(today, 1);
    const end = endOfDay(addDays(today, UPCOMING_WINDOW_DAYS));
    return activeTasks.filter((task) => isActiveInWindow(task, { start, end }));
  }, [activeTasks, today]);
};
